define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/XMLUtil',
	'model/Attribute',
	'model/Origin',
	'lib/jquery'
], function (
		Logger,
		Util,
		XMLUtil,
		Attribute,
		Origin,
		jQuery
		) {
	'use strict';

	/**
	 * AttributesFactory class
	 */
	return new function () {
		var namespace = 'urn:oasis:names:tc:SAML:2.0:assertion';


		// public methods

		this.create = function (attributesXML) {
			attributesXML = jQuery(attributesXML);

			var attributes = new Array(),
					attributeNodes = XMLUtil.find(namespace, attributesXML, 'Attribute'),
					attributeName,
					attributeValue,
					attributeOriginPrt,
					attributeOriginIss,
					attributeOriginTyp,
					attributeOrigin,
					i;

			for (i = 0; i < attributeNodes.length; i++) {
				attributeNodes[i] = jQuery(attributeNodes[i]);

				attributeName = attributeNodes[i].attr('Name').trim();
				attributeValue = XMLUtil.find(namespace, attributeNodes[i], 'AttributeValue').text().trim();

				attributeOriginPrt = XMLUtil.getAttribute(attributeNodes[i], 'OriginIDAuthProtocol', 'http://www.skidentity.de/att');
				attributeOriginIss = XMLUtil.getAttribute(attributeNodes[i], 'OriginIDIssuer', 'http://www.skidentity.de/att');
				attributeOriginTyp = XMLUtil.getAttribute(attributeNodes[i], 'OriginIDType', 'http://www.skidentity.de/att');
				
				if (Util.isValidString(attributeOriginTyp) && Util.isValidString(attributeOriginPrt)) {
					attributeOrigin = new Origin(attributeOriginTyp, attributeOriginPrt, attributeOriginIss);
				} else {
					attributeOrigin = null;
				}


				attributes.push(new Attribute(attributeName, attributeValue, attributeOrigin));
			}

			return attributes;
		};

		this.createFromObject = function (attributeObject) {
			var attributes,
					i;

			if (Util.isArray(attributeObject)) {
				attributes = new Array();

				for (i = 0; i < attributeObject.length; i++) {
					attributes.push(new Attribute(attributeObject[i]['name'], attributeObject[i]['value'], attributeObject[i]['origin']));
				}
			} else {
				attributes = new Attribute(attributeObject['name'], attributeObject['value'], attributeObject['origin']);
			}

			return attributes;
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/factory/AttributesFactory.js
// module id = 92
// module chunks = 8